module.exports = __webpack_public_path__ + "static/media/LEDCube.775542e4.mp4";